<!--
 * @Description:市场营销-投放记录
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-05-05 11:07:22
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        rowKey="cluePushRecordId"
        :row-selection="{ onChange: onSelectChange }"
        :columns="columns"
        serial
        @fetch="fetch"
        ref="tableRef"
        tableId="DcCosLbuDeliveryRecord"
        v-model:search="searchFrom"
      >
        <template #search>
          <a-form :model="searchFrom">
            <dc-form-item name="pushResult" label="投放结果">
              <a-radio-group
                v-model:value="searchFrom.pushResult"
                optionType="button"
                @change="search"
                :options="[
                  { label: '全部', value: undefined },
                  { label: '成功', value: 1 },
                  { label: '失败', value: 0 }
                ]"
              />
            </dc-form-item>
            <dc-form-item label="线索类型">
              <a-select
                v-model:value="searchFrom.clueType"
                allowClear
                placeholder="请选择"
                :options="dataConfig.clueType"
              />
            </dc-form-item>
            <dc-form-item name="customerName" label="客户名称">
              <a-input v-model:value="searchFrom.customerName" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="ID">
              <a-input v-model:value="searchFrom.clueId" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="投放时间">
              <cos-range-picker
                v-model:startTime="searchFrom.createStartTime"
                v-model:endTime="searchFrom.createEndTime"
              />
            </dc-form-item>
            <dc-form-item label="投放人">
              <user-select v-model:value="searchFrom.operator" />
            </dc-form-item>
            <dc-form-item label="手机号">
              <a-input v-model:value="searchFrom.mobile" placeholder="请输入" />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <a-button @click="handleInvalid" v-permission="'lbu_lead_invalid_btn'"> 置为无效 </a-button>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'action'">
            <!--置为无效：未投放的有效线索/新线索 -->
            <a-button
              type="link"
              @click="handleInvalid(record)"
              v-show="record.clueStatus === 0 && record.clueType !== 3"
              v-permission="'lbu_lead_invalid_btn'"
            >
              置为无效
            </a-button>
          </template>
        </template>
      </cos-table>
      <!--置为无效-->
      <invalid-model ref="invalidModelRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import type { ClueManage, ClueManageParams } from '@/typings/api/marketingManage'
import { cluePushRecordList } from '@/api/marketing/marketingManage'
import InvalidModel from '@/views/yuntuSales/marketLeads/components/invalidModel.vue'
import CosRangePicker from '@/components/CosRangePicker'
const invalidModelRef = ref()
const tableRef = ref()
const searchFrom = ref<ClueManageParams>({})
const selectedRows = ref<any[]>([])
const fetch = (params: object, callBack: (res: any) => void) => {
  cluePushRecordList(params).then((res) => {
    callBack(res)
  })
}
const onSelectChange = (selectedRowKeys: string[], rows: ClueManage[]) => {
  selectedRows.value = rows
}
const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value.search()
  } else {
    tableRef.value.fetch()
  }
}
const search = () => {
  tableRef.value.search()
}
// 置为无效
const handleInvalid = (row?: ClueManage) => {
  let result = []
  if (row && row.clueId) {
    result.push(row)
  } else {
    result = selectedRows.value
  }
  invalidModelRef.value.toggle(result)
}
const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    path: '/lbu/deliveryRecord/view',
    query: ['clueId', 'contact_contactRefId'],
    width: 200
  },
  {
    title: 'ID',
    dataIndex: 'clueId',
    width: 200
  },
  {
    title: '投放人',
    dataIndex: 'operatorName'
  },
  {
    title: '投放时间',
    dataIndex: 'createTime',
    width: 190
  },
  {
    title: '手机号',
    dataIndex: ['contact', 'mobile'],
    width: 140
  },
  {
    title: '投放结果',
    dataIndex: 'pushResult',
    dicData: dataConfig.cluePushResultEnum
  },
  {
    title: '失败原因',
    dataIndex: 'resultDesc',
    width: 200
  },
  {
    title: '线索类型',
    dataIndex: 'clueType',
    dicData: dataConfig.clueType
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 120
  }
])
</script>
<script lang="ts">
export default { name: 'DcCosLbuDeliveryRecord' }
</script>
